import styled from 'styled-components';

export const Divider = styled.div`
  grid-column: 1 / -1;

  width: 100%;
  height: 1px;
  min-height: 1px;
  flex-shrink: 0;

  background-color: ${({ theme }) => theme.palette.grey[400]};
  margin: ${({ theme }) => `${theme.spacing(2)} 0`};
`;
